import axios from '../services/axios';
import $axios from 'axios'
const server = {
    json(params){//上传人脸识别图片
        return axios('https://acme-public.oss-cn-beijing.aliyuncs.com/interactive/ai.json', {
            // return axios('https://acme-mono.oss-cn-beijing.aliyuncs.com/apps/drawing/0002b7a0-7f73-4972-89f1-e8414f460468.json?Expires=1617732858&OSSAccessKeyId=TMP.3Kk5GWane6RKGAYMxHtmqQnUbVydmPazKN2TGFNaEXkfQdsAtyiziNn3eYaw19snKKAQs4rHVBr7c6jHrQQRPSxyLU2nmz&Signature=AGXUImJuzKYjG9rm5QXB2xQBhWg%3D', {
            method: 'get',
            params
        })
    },
    getTeamList(params) {//获取所有球队列表
        return axios('/teams', {
            method: 'get',
            params
        })
    },
    getAllWorkitem(params) {//获取所有球队列表
        return axios('/statistics/week/workitem', {
            method: 'get',
            params
        })
    },
    getPlayersList(params) {//获取球队内所有球员列表
        return axios('/team/players', {
            method: 'get',
            params
        })
    },
    getNoPlayerList(params) {//获取球队非球员信息--职员
        return axios('/team/staff', {
            method: 'get',
            params
        })
    },
    getUserTeams(params) {//获取球员基本信息--所在梯队列表
        return axios('/user/teamNames', {
            method: 'get',
            params
        })
    },
    getPlayersReportWeekAll(params) {//获取所有周数据--柱状图显示
        return axios('/evaluation_report/all', {
            method: 'get',
            params
        })
    },
    getPlayersReportList(params) {//获取评估项
        return axios('/evaluation/question', {
            method: 'get',
            params
        })
    },
    getUserList(params) {//获取用户列表
        return axios('/users', {
            method: 'get',
            params
        })
    },
    getUserMsg(params) {//获取人员信息
        return axios('/user', {
            method: 'get',
            params
        })
    },
    pushImgOss(data){//上传人脸识别图片
        let instance = $axios.create({});
        return instance.post('/search_face', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    userSearch(params){//根据条件查询用户
        return axios('/player/search', {
            method: 'get',
            params
        })
    },
    teamReport(params){//梯队情况
        return axios('/asr/team/overview', {
            method: 'get',
            params
        })
    },
    weekSchedule(params) {//当周和当天训练日程
        return axios('/schedule/week', {
            method: 'get',
            params
        })
    },
    schedule(params){//赛程
        return axios('/statistics/schedule', {
            method: 'get',
            params
        })
    },
    // gps报告模块 --  gps数据 -- 筛选项请求（跑动距离等）  /catapult/params
    getGpsFilter(params) {
        //梯队球员数据
        return axios('/catapult/params', {
            method: 'get',
            params,
        });
    },
    gpsReport(params){//运动表现--GPS
        return axios('/gps/report', {
            method: 'get',
            params
        })
    },
    nowWeek(params){//计算当前周编号
        return axios('/current_week_index', {
            method: 'get',
            params
        })
    },
    nowWeekArr(params){
        return axios('/schedule/weeks', {
            method: 'get',
            params
        })
    },
    // injuryHistory(params) {//伤病历史
    //     return axios('/injury/history', {
    //         method: 'get',
    //         params
    //     })
    // },
    // injuryDetail(params) {//当前伤病信息
    //     return axios('/injury/current', {
    //         method: 'get',
    //         params
    //     })
    // },
    injuryHistory(params) {//伤病历史
        return axios('/asr/injuries', {
            method: 'get',
            params
        })
    },
    injuryDetail(params) {//当前伤病信息
        return axios('/injury/current', {
            method: 'get',
            params
        })
    },
    getACReport(params) {//AC报告
        return axios('/gps/ac_report', {
            method: 'get',
            params
        })
    },
    getAIMReport(params) {//AIM报告
        return axios('/gps/aim_report', {
            method: 'get',
            params
        })
    },
    getGPSAIMReport(params) {//强度报告
        return axios('/gps/intensity_report', {
            method: 'get',
            params
        })
    },
    physicalTestLabel(params) {//体测报告
        return axios('/list_physical_test', {
            method: 'get',
            params
        })
    },
    getAgilityReport(params){
        return axios('/agility_report', { //体测 agility数据报告
            method: 'GET',
            params
        })
    },
    getAphvReport(params){
        return axios('/aphv_report', { //体测 aphv数据报告
            method: 'GET',
            params
        })
    },
    getYoyoReport(params){
        return axios('/yoyo_report', { //体测 yoyo数据报告
            method: 'GET',
            params
        })
    },
    getSpeedReport (params){
        return axios('/speed_report', { //体测 yoyo数据报告
            method: 'GET',
            params
        })
    },
    getAntroReport (params){
        return axios('/antro_report', { //体测 yoyo数据报告
            method: 'GET',
            params
        })
    },
    commonDataTit(params) {//获取所有职员对应的中英文
        return axios('/common/data', {
            method: 'get',
            params
        })
    },
    //日期转换年周
    weekOfYear(params) {
        return axios('/schedule/weekOfYear', {
            method: 'get',
            params,
        });
    },
    getExerciseList(params) {
        //练习教案list
        return axios('/exercise/list', { //教案
            method: 'get',
            params,
        });
    },
    getExerciseDetail(params) {
        //练习教案详情
        return axios('/exercise', {
            method: 'get',
            params,
        });
    },
    getVideoList(params) {
        //视频list
        return axios('/asr/videos', {
            method: 'get',
            params,
        });
    },
    getVideoClipsList(params) {
        //视频list
        return axios('/video/clips', {
            method: 'get',
            params,
        });
    },
    getVideo(params) {
        return axios('/video', {
            //视频详情
            method: 'GET',
            params,
        });
    },
    getLineUp(params) {
        return axios('/lineup', {
            //视频详情
            method: 'GET',
            params,
        });
    },
}
export default server
